var onField = function (_a) {
    var _b, _c;
    var entry = _a[0], _d = _a[1], array = _d === void 0 ? [] : _d, _e = _a[2], initial = _e === void 0 ? [] : _e;
    return (_c = (_b = array === null || array === void 0 ? void 0 : array.reduce(function (previous, current) {
        previous === null || previous === void 0 ? void 0 : previous.push(current[entry]);
        return previous;
    }, initial)) === null || _b === void 0 ? void 0 : _b.filter(Boolean)) !== null && _c !== void 0 ? _c : [];
};
var groupBy = function (_a) {
    var _b;
    var entries = _a[0], _c = _a[1], array = _c === void 0 ? [] : _c, _d = _a[2], initial = _d === void 0 ? {} : _d;
    return (_b = array === null || array === void 0 ? void 0 : array.reduce(function (previous, current) {
        entries === null || entries === void 0 ? void 0 : entries.forEach(function (entry) {
            var _a;
            var value = current[entry];
            if (value) {
                (_a = previous[value]) !== null && _a !== void 0 ? _a : (previous[value] = []);
                previous[value].push(current);
            }
        });
        return previous;
    }, initial)) !== null && _b !== void 0 ? _b : {};
};
var reducers = {
    GROUP_BY: groupBy,
    ON_FIELD: onField,
};
var reduceResolver = function (params) {
    if (params && params instanceof Object && Object.keys(params).length === 1) {
        var _a = Object.entries(params).pop(), operation = _a[0], data = _a[1];
        if (operation && reducers[operation]) {
            return reduceResolver(reducers[operation](data));
        }
    }
    return params;
};
export default function (params) {
    return reduceResolver(params);
}
//# sourceMappingURL=rave-reduce.js.map